import { Box } from "@mui/material";
import React from "react";
import PreviewPaneCQVisual from "src/modules/flow-designer/preview-pane/preview-pane-cq-visual";

const ForeseerGraph: React.FC = () => {
    return (
        <Box sx={{ height: "500px", width: "100%" }}>
            <PreviewPaneCQVisual height={500} width={1000} />
        </Box>
    );
};

export default ForeseerGraph;
